import React, { Component } from 'react';
import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import { Container } from 'reactstrap';

class Layout extends Component {
    render() {
        return (
            <Container>
                <Header user={this.props.user} />
                {this.props.children}
                <hr/>
                <Footer />
                <br/>
            </Container>
        );
    }
}

export default Layout;


// WEBPACK FOOTER //
// ./src/hoc/layout.js